import { DeleteMessageSetMessage, DeleteMessageSetMessageVariables } from './__generated__/DeleteMessageSetMessage'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation DeleteMessageSetMessage($input: DeleteMessageSetMessageInputV2!) {
    deleteMessageSetMessageV2(input: $input) {
      ... on MessageSetMessageErrorV2 {
        type
        error
      }
      ... on MessageSetMessageV2 {
        id
        messageId
        messageId
      }
    }
  }
`

export const useDeleteMessageSetMessage = () =>
  useMutation<DeleteMessageSetMessage, DeleteMessageSetMessageVariables>(MUTATION)
